export default __webpack_public_path__ + "static/media/IMG_2681cropped.622dc0fc.jpeg";